import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, V1 } from "@/lib/api";
import { BookOpen, Clock, Sparkles, ArrowRight } from "lucide-react";

const ICONS = {
  erken_kayit: "🎓",
  bursluluk: "💰",
  yaz_okulu: "☀️",
  donem_kayit: "📅",
};

export default function SchoolArticlesSection({ school }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!school?.slug) return;
    api.get(`${V1}/schools/${school.slug}/articles`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [school?.slug]);

  useEffect(() => {
    // If pending articles exist, poll every 30s (background generation)
    if (data?.pending?.length > 0) {
      const t = setInterval(() => {
        api.get(`${V1}/schools/${school.slug}/articles`).then((r) => setData(r.data)).catch(() => {});
      }, 30000);
      return () => clearInterval(t);
    }
  }, [data?.pending?.length, school?.slug]);

  if (!data) return null;
  const all = [
    ...(data.articles || []).map((a) => ({ ...a, ready: true })),
    ...(data.pending || []).map((a) => ({ ...a, ready: false })),
  ];
  if (all.length === 0) return null;

  return (
    <section data-testid="school-articles-section">
      <div className="flex items-center gap-2 mb-4">
        <BookOpen className="h-5 w-5 text-primary" />
        <h2 className="font-display text-2xl font-bold">{school.name} Rehberi ({data.year})</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        {school.district}, {school.province} bölgesindeki aday veliler için hazırlanmış {data.year} eğitim öğretim yılı rehber makaleleri.
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        {all.map((a) => (
          <div key={a.type} className="p-5 rounded-xl border border-border bg-card hover:border-primary/40 transition group" data-testid={`article-card-${a.type}`}>
            <div className="text-3xl mb-3">{ICONS[a.type] || "📄"}</div>
            <div className="font-display font-bold text-lg mb-2 group-hover:text-primary transition">{a.title}</div>
            {a.excerpt && <div className="text-sm text-muted-foreground line-clamp-2">{a.excerpt}</div>}
            <div className="mt-4 flex items-center justify-between">
              {a.ready ? (
                <>
                  <span className="text-xs text-muted-foreground flex items-center gap-1">
                    <Clock className="h-3 w-3" /> {a.read_minutes} dk okuma
                  </span>
                  <Link
                    to={`/okul/${school.slug}/makale/${a.slug}`}
                    className="text-sm font-medium text-primary hover:underline flex items-center gap-1"
                    data-testid={`article-link-${a.type}`}
                  >
                    Oku <ArrowRight className="h-3.5 w-3.5" />
                  </Link>
                </>
              ) : (
                <span className="text-xs text-accent flex items-center gap-1 animate-pulse">
                  <Sparkles className="h-3 w-3" /> AI Hazırlıyor…
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
